import * as React from "react";

export interface CroutonContextContextValue {
    croutonState: {
        title: string;
        icon?: string;
        durationOfCrouton?: number;
        postTextIcon?: string;
        cssProperties?: React.CSSProperties;
        buttonClassName?: string;
        onClick?: VoidFunction;
        impressionEvent?: VoidFunction;
    };
    setCroutonState: (state: CroutonContextContextValue["croutonState"]) => void;
}

export const CroutonContext = React.createContext<CroutonContextContextValue>({
    croutonState: {
        title: "",
    },
    setCroutonState: () => void 0,
});

if (__DEV__) {
    CroutonContext.displayName = "CroutonContext";
}
